import React, { useState } from "react"
import TableCustom from "../../components/TableCustom"
import Input from "../../components/Input"
import { CircularProgress, Grid, IconButton } from "@mui/material"
import Vista from "../../components/Vista"
import dateComponent from "../../components/dateComponent"
import SettingsIcon from "@mui/icons-material/Settings"
import { useModal } from "../../hooks/useModal"
import Permisos from "./permiso"

const Usuario = ({ onClick, onKeyDown, ...props }) => {
  const busquedaDefault = {
    correo: "",
    fechaInicio: dateComponent.getFirstDayOfYear(),
    fechaFinal: dateComponent.getActualDay()
  }
  const [busqueda, setBusqueda] = useState({ ...busquedaDefault })
  const { setOpen, setContainerModal } = useModal()

  const openModal = (permisos, idUsuario) => {
    setContainerModal(
      <Permisos permisos={permisos} setOpen={setOpen} idUsuario={idUsuario} />
    )
  }

  let dataTable = {
    nombreProducto: {
      nombre: "Nombre Completo",
      content: (row) => {
        return row.nombreCompleto
      }
    },
    categoria: {
      nombre: "Correo",
      content: (row) => {
        return row.correo
      }
    },
    permisos: {
      nombre: "Permisos",
      content: (row) => {
        return (
          <IconButton
            onClick={(e) => {
              // duplicarPermisos(row?.permisos[0]);
              openModal(row?.permisos[0], row?.idUsuario)
            }}
          >
            <SettingsIcon />
          </IconButton>
        )
      }
    }
  };

  let dataPdf = {
    nombreProducto: {
      nombre: "Nombre Completo",
      content: (row) => {
        return row.nombreCompleto
      }
    },
    categoria: {
      nombre: "Correo",
      content: (row) => {
        return row.correo
      }
    },

  };

  return (
    <Vista>
      <TableCustom
        tipo={"idUsuario"}
        busqueda={busqueda}
        setBusqueda={setBusqueda}
        dataTable={dataTable}
        dataPdf={dataPdf}
        expand={"permisos.sucursal"}
        permisoCheck={"usuarios"}
        nombreBusqueda={["nombreCompleto", "correo"]}
      />
    </Vista>
  )
}

export default Usuario
